import { Routes } from '@angular/router';
import { ContestComponent } from 'app/features/contest/contest.component';
import { HomeComponent } from 'app/features/home/home.component';
import { ErrorStateComponent } from 'app/shared/ui/error-state/error-state.component';
import { GoalComponent } from './features/goal/goal.component';
import { UsernameResolver } from './features/goal/routing/username.resolver';
import { DistanceResolver } from './features/goal/routing/distance.resolver';

export const routes: Routes = [
  { component: HomeComponent, path: '' },
  { component: ContestComponent, path: 'contest/:username/:hashid' },
  {
    component: GoalComponent,
    path: 'contest/:username/goal/:distance',
    resolve: {
      username: UsernameResolver,
      distance: DistanceResolver,
    },
  },
  { component: ErrorStateComponent, path: 'error/:errorCode' },
  { path: '**', redirectTo: '' },
];
